import { Button, IconButton } from '@fullscreendigital/carrefour-dex-fe'
import { Box, CircularProgress, Grid, useMediaQuery } from '@mui/material'
import { Modal } from 'components/core-ui/Modal'
import { useEffect, useRef, useState } from 'react'
import { useReactToPrint } from 'react-to-print'
import s from 'components/core-ui/Modal/Modal.modules.scss'
import { Document, Page } from 'react-pdf'
import { useNotification } from 'hooks'
import { ChevronLeft, ChevronRight } from '@mui/icons-material'

const PrintPreviewModal = props => {
  const { isModalOpen, closeModal, pdfBlob, isPdfBlobLoading, printScale } = props

  const [scale, setScale] = useState(1.0)
  const [numPages, setNumPages] = useState(null)
  const [pageNumber, setPageNumber] = useState(1)

  const componentRef = useRef(null)

  const { showNotification } = useNotification()

  const printReport = useReactToPrint({
    content: () => componentRef.current
  })

  const isXs = useMediaQuery('(max-width:624px)')

  useEffect(() => {
    setScale(isXs ? 0.5 : 1.0)
  }, [isXs])

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages)
    setPageNumber(1) // reset to first page
  }

  const onDocumentLoadError = error => {
    if (error?.message == 'Worker was destroyed') {
      return
    }

    showNotification({
      message: `A aparut o eroare la descarcarea fisierului. ${error.message}`,
      type: 'error'
    })
  }

  const goToPrevPage = () => setPageNumber(prevPage => Math.max(prevPage - 1, 1))

  const goToNextPage = () => setPageNumber(prevPage => Math.min(prevPage + 1, numPages))

  return (
    <Modal isModalOpen={isModalOpen} closeModal={closeModal} modalTitle={''} modalWidth="50%">
      <Grid container spacing={4}>
        <Grid xs={12} item style={{ textAlign: 'center', minHeight: isXs ? '400px' : '800px' }}>
          {isPdfBlobLoading ? (
            <CircularProgress color="primary" style={{ margin: '40px auto' }} />
          ) : (
            <Box>
              <Box>
                <IconButton
                  onClick={goToPrevPage}
                  startIcon={<ChevronLeft />}
                  variant="text"
                  disabled={pageNumber <= 1}
                />
                <span>
                  Page {pageNumber} of {numPages}
                </span>
                <IconButton
                  onClick={goToNextPage}
                  startIcon={<ChevronRight />}
                  variant="text"
                  disabled={pageNumber >= numPages}
                />
              </Box>
              <Box>
                <Document
                  file={pdfBlob}
                  onLoadSuccess={onDocumentLoadSuccess}
                  onLoadError={onDocumentLoadError}
                  loading={<CircularProgress color="primary" style={{ margin: '40px auto' }} />}
                >
                  <Page
                    pageNumber={pageNumber}
                    scale={scale}
                    loading={<CircularProgress color="primary" style={{ margin: '40px auto' }} />}
                    renderAnnotationLayer={false}
                    renderTextLayer={false}
                  />
                </Document>
              </Box>
              <Box style={{ display: 'none' }}>
                <Box ref={componentRef}>
                  <Document
                    file={pdfBlob}
                    onLoadSuccess={onDocumentLoadSuccess}
                    onLoadError={onDocumentLoadError}
                    loading={<CircularProgress color="primary" style={{ margin: '40px auto' }} />}
                  >
                    {Array.from(new Array(numPages), (el, index) => (
                      <Page
                        key={`page_${index + 1}`}
                        pageNumber={index + 1}
                        scale={printScale || 1.5}
                        loading={
                          <CircularProgress color="primary" style={{ margin: '40px auto' }} />
                        }
                        renderAnnotationLayer={false}
                        renderTextLayer={false}
                      />
                    ))}
                  </Document>
                </Box>
              </Box>
            </Box>
          )}
        </Grid>
        <Grid xs={12} item className={s.modalButtons}>
          <Button variant="outlined" label="Anuleaza" onClick={closeModal} />
          <Button variant="contained" type="submit" label="Printeaza" onClick={printReport} />
        </Grid>
      </Grid>
    </Modal>
  )
}

export default PrintPreviewModal
